import React from "react";

const GroupTab = ({ children, onClick }) => {
  return (
    <>
      {children.map((child) => (
        <div
          className="trainingChildrenContainer"
          onClick={() => onClick(child)}
          key={child.id}
        >
          <span className="trainingChildName">
            {child.last_name} {child.first_name} {child.middle_name}
          </span>
        </div>
      ))}
    </>
  );
};

export default GroupTab;
